import React from "react";
import PropTypes from "prop-types";
import BaseModal from "react-modal";

export default function Modal({
  isOpen,
  onClose,
  heading,
  children,
  contentLabel,
  customContentStyle,
  customTextColor = "tw-text-white",
}) {
  const defaultContentStyle = {
    maxWidth: "35rem",
    maxHeight: "20rem",
    marginLeft: "auto",
    marginRight: "auto",
    background: "rgba(0, 122, 132, 1)",
    border: 0,
  };

  return (
    <div>
      <BaseModal
        isOpen={isOpen}
        onRequestClose={() => {}}
        style={{
          overlay: {
            zIndex: 10,
          },
          content: customContentStyle || defaultContentStyle,
        }}
        contentLabel={contentLabel}
        ariaHideApp={false}
      >
        <div className={`${customTextColor} tw-font-sans`}>
          <div className="tw-flex tw-mb-6">
            <div className="tw-my-auto">{heading}</div>
            <div className="tw-my-auto tw-ml-auto">
              <button aria-label="Close modal" onClick={onClose} className="tw-bg-transparent	tw-border-0 tw-m-auto hover:tw-cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  fill="none"
                  viewBox="0 0 48 48"
                >
                  <g>
                    <path
                      fill={customTextColor === "tw-text-gray-900" ? "#111827" : "#fff"}
                      fillRule="evenodd"
                      d="M25.414 28.243a2 2 0 00-2.828 0l-9.172 9.171a2 2 0 11-2.828-2.828l9.171-9.172a2 2 0 000-2.828l-9.171-9.172a2 2 0 112.828-2.828l9.172 9.171a2 2 0 002.828 0l9.172-9.171a2 2 0 112.828 2.828l-9.171 9.172a2 2 0 000 2.828l9.171 9.172a2 2 0 11-2.828 2.828l-9.172-9.171z"
                      clipRule="evenodd"
                    ></path>
                  </g>
                </svg>
              </button>
            </div>
          </div>
          {children}
        </div>
      </BaseModal>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  contentLabel: PropTypes.string.isRequired,
};

Modal.defaultProps = {
  isOpen: false,
  onClose: () => {},
};
